import { Box, Button, Container, Divider, IconButton, Typography } from "@mui/material";
import React, { useState, useRef } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import MasterSharingTab from "./MasterSharingTab";
import MasterSharingCriteriaTab from "./MasterSharingCriteriaTab";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { postRequest, getRequest } from "../services/api.request";
import { toast } from 'react-toastify';

const MasterSharingAdd = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [saving, setSaving] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [templateId, setTemplateId] = useState(null);
  const formDataRef = useRef(null);
  const navigate = useNavigate();
  const params = useParams();

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleFormChange = (data) => {
    formDataRef.current = { ...formDataRef.current, ...data };
  };

  const handleSubmit = async (e) => {
    if (!formDataRef.current) {
      return;
    }
    
    setSaving(true);
    try {
      if (isEditMode) {
        const response = await postRequest(`/sharing-templates/v1/${templateId}`, formDataRef.current, 'PUT');
        if (response && response.success) {
          toast.success('Template updated successfully!');
          navigate('/master/sharing');
        } else {
          const errorMessage = response?.message || 'Failed to update template';
          toast.error(errorMessage);
        }
      } else {
        const response = await postRequest('/sharing-templates/v1', formDataRef.current);
        if (response && response.success) {
          toast.success('Template saved successfully!');
          navigate('/master/sharing');
        } else {
          const errorMessage = response?.message || 'Failed to save template';
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      console.error('Error saving template:', error);
      toast.error(error.message || 'Failed to save template');
    } finally {
      setSaving(false);
    }
  };

  const getTemplate = async () => {
    try {
      const response = await getRequest(`/sharing-templates/v1/${templateId}`);
      if (response && response.success) {
        formDataRef.current = response.data;
      } else {
        const errorMessage = response?.message || 'Failed to fetch template';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error fetching template:', error);
      toast.error(error.message || 'Failed to fetch template');
    }
  };

  React.useEffect(() => {
    if (params.id) {
      setIsEditMode(true);
      setTemplateId(params.id);
      getTemplate();
    }
  }, [params.id]);

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              padding: 2,
              marginTop: 2,
              borderRadius: 2,
              marginRight: "90px",
            }}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                color: "#5D6A82",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: "bold",
                padding: 0,
                transition: "none !important",
                marginBottom: "16px",
              }}
            >
              Back
            </Button>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 0,
                mb: "20px",
                color: "#5D6A82",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "20px",
                  lineHeight: "29px",
                  letterSpacing: "0px",
                  color: "inherit",
                }}
              >
                {isEditMode ? "Edit Sharing Template" : "Add Sharing Template"}
              </Typography>
            </Box>

          {/* tabs */}
          <Box
            sx={{
              border: "1px solid grey",
              borderRadius: "5px",
              px: 2,
              py: 0.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              width: "200px",
              cursor: "pointer",
              mb: "20px",
            }}
          >
            <Typography
              onClick={() => handleTabClick(0)}
              sx={{
                color: "grey",
                textDecoration: "none",
                ...(activeTab === 0 && {
                  color: "primary.main",
                  fontWeight: 600,
                  textDecoration: "underline",
                  textUnderlineOffset: "4px",
                }),
              }}
            >
              Sharing
            </Typography>
            <Divider flexItem orientation="vertical" />
            <Typography
              onClick={() => handleTabClick(1)}
              sx={{
                color: "grey",
                textDecoration: "none",
                ...(activeTab === 1 && {
                  color: "primary.main",
                  fontWeight: 600,
                  textDecoration: "underline",
                  textUnderlineOffset: "4px",
                }),
              }}
            >
              Criteria
            </Typography>
          </Box>

          {/* tab */}
          {activeTab === 0 && <MasterSharingTab template={isEditMode ? { _id: templateId } : null} onChange={handleFormChange} />}
          {activeTab === 1 && <MasterSharingCriteriaTab template={isEditMode ? { _id: templateId } : null} onChange={handleFormChange} />}
          
          {/* Action Buttons - Only show in edit mode */}
          {isEditMode && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  handleSubmit(e);
                }}
                disabled={saving}
                sx={{ minWidth: '150px' }}
              >
                {saving ? 'Saving...' : 'Save'}
              </Button>
            </Box>
          )}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default MasterSharingAdd;
